/**
 * Date Picker Modes
 */
export const MODE = {
  DATE: 'date' /* Date picker */,
  DATE_TIME: 'datetime' /* Date & time picker */,
  TIME: 'time' /* Time picker */,
};

/**
 * Minute Increment Values
 */
export const MINUTE_INCREMENT = {
  BY_FIVE: 5,
  BY_TEN: 10,
  BY_FIFTEEN: 15,
  BY_TWENTY: 20,
  BY_THIRTY: 30,
};

/**
 * Available Date & Time Format for Date Picker
 */
export const FORMAT = {
  DATE_DEFAULT: 'MM/DD/YYYY' /* Eg: 01/09/2021 */,
  DATE_TIME_DEFAULT: 'MM/DD/YYYY hh:mm A' /* Eg: 01/09/2021 10:20 PM */,
  TIME_DEFAULT: 'hh:mm A' /* Eg: 10:20 PM */,
  DATE_WITH_HYPHEN: 'MM-DD-YYYY' /* Eg: 01-09-2021 */,
};

export const DATE_PICKER_CONFIG_BY_FORMAT = {
  [FORMAT.DATE_DEFAULT]: {
    format: FORMAT.DATE_DEFAULT,
    checkFormat: 'MM/dd/yyyy',
  },
  [FORMAT.TIME_DEFAULT]: {
    format: FORMAT.TIME_DEFAULT,
    checkFormat: 'hh:mm a',
  },
  [FORMAT.DATE_WITH_HYPHEN]: {
    format: FORMAT.DATE_WITH_HYPHEN,
    checkFormat: 'MM-dd-yyyy',
  },
};
